var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "google-map",
    {
      staticClass: "py-lg-50 py-30",
      attrs: { center: _vm.mapCenter, zoom: 15, options: _vm.mapOpts }
    },
    [
      _c(
        "google-info-window",
        {
          attrs: {
            options: _vm.infoOptions,
            position: _vm.infoWindowPos,
            opened: _vm.infoWinOpen
          },
          on: {
            closeclick: function($event) {
              _vm.infoWinOpen = false
            }
          }
        },
        [
          _c("div", { staticClass: "text-center pt-4 pb-4 px-3" }, [
            _c("p", {
              staticClass: "xsmall font-weight-heavy",
              domProps: { innerHTML: _vm._s(_vm.infoContent.title) }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "xxxsmall",
              domProps: { innerHTML: _vm._s(_vm.infoContent.descr) }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("google-marker", {
        attrs: {
          icon: _vm.mapIcon,
          position: { lat: 38.064318, lng: 23.746232 }
        },
        on: {
          click: function($event) {
            return _vm.toggleInfoWindow(
              { lat: 38.064318, lng: 23.746232 },
              {
                title: "<p class='mb-2'>PAPA-PASTRY</p>",
                descr: "Λ. ΙΩΝΙΑΣ 104,<br>ΑΧΑΡΝΑΙ - ΑΤΤΙΚΗ,<br>Τ.Κ 136 73",
                directions:
                  "https://www.google.com/maps/dir/?api=1&destination=Χαρ.+Τρικούπη+151,+Κηφισιά+145+64",
                tel: "+30 210 80 72 770"
              }
            )
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }